export default [
  {
    path: '/dados',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Dados',
        path: '',
        component: () => import('@/views/dados/Index.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados' }]
        }
      }
    ]
  }
];
